import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";
// const token = localStorage.getItem('token')

export const ValidateUser = createAsyncThunk(
  "dummyData/ValidateUser",
  async ({loginToken}, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("ots_token") || localStorage.getItem("ots_token") || loginToken;

      let response = await axios.post(
        `${BASE_URL}/validateUser`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Only return serializable data, not the full Axios response
      return { data: response.data, status: response.status };
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || "Validation failed",
      });
    }
  }
);

const UserValidate = createSlice({
  name: "userValidate",
  initialState: {
    loading: false,
    UserValidate: [],
    error: "",
  },
  extraReducers: {
    [ValidateUser.fulfilled]: (state, action) => {
      state.UserValidate = action.payload;
      state.loading = false;
    },
    [ValidateUser.pending]: (state) => {
      state.loading = true;
    },
    [ValidateUser.rejected]: (state, action) => {
      state.UserValidate = [];
      state.error = action.error;
    },
  },
});
export default UserValidate.reducer;
